import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { IFilterOption } from '@rankmi/rankmi-table/dist/interfaces/filterProps'
import { useSelector } from 'react-redux'

import { IMainState } from 'store/states'
import { joinKeys } from 'helpers/translations.helper'
import { prefix as prefixBase } from '../constants'
import { ParticipantsColumns } from './useColumns/constants'

interface Column extends IFilterOption {
  label: string
  type: string
  value: string
}

export const useFiltersColumns = () => {
  const prefixHeaders = joinKeys(prefixBase, 'table.headers')

  const { t } = useTranslation()

  const lmsProfileList = useSelector(
    ({ lmsProfiles }: IMainState) => lmsProfiles.allProfilesList
  )

  const filtersColumns = useMemo(
    (): Column[] => [
      {
        label: t(`${prefixHeaders}.name`),
        value: ParticipantsColumns.name,
        type: 'string',
      },
      {
        label: t(`${prefixHeaders}.area`),
        value: ParticipantsColumns.area,
        type: 'string',
      },
      {
        label: t(`${prefixHeaders}.lms_profiles`),
        value: ParticipantsColumns.lmsProfilesId,
        type: 'tagsList',
        list: lmsProfileList
          .map(({ id, name, color }) => ({ value: id, label: name, color }))
          .sort((A, B) => A.label.localeCompare(B.label)),
      },
      {
        label: t(`${prefixHeaders}.courses`),
        value: ParticipantsColumns.coursesCount,
        type: 'number',
      },
      {
        label: t(`${prefixHeaders}.progress`),
        value: ParticipantsColumns.coursesAdvance,
        type: 'number',
      },
      {
        label: t(`${prefixHeaders}.lmsActive`),
        value: ParticipantsColumns.lmsActive,
        type: 'tagsList',
        list: [true, false].map((value) => ({
          value: String(value),
          label: t(`${prefixHeaders}.lmsActiveList.${value}`),
        })),
      },
      {
        label: t(`${prefixHeaders}.progressEvaluations`),
        value: ParticipantsColumns.evaluationsApproved,
        type: 'number',
      },
    ],
    [lmsProfileList, prefixHeaders, t]
  )
  return filtersColumns
}
